<div>
  <app-operations-vs-overhead-filters *ngIf="years"
    [years]="years"
    [countries]="countries"
    [collectionStreams]="collectionStreams"
    (search)="searchData($event)">
  </app-operations-vs-overhead-filters>
  <mat-divider></mat-divider>
  <app-operations-vs-overhead-pie-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [order]="order"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-operations-vs-overhead-pie-chart>
</div>
